<template>
  <div>
    <button
      class="checkbox"
      @click="handler()"
      @mouseover="mouseOver()"
      @mouseout="mouseOut()"
    >
      <img
        v-if="selected"
        value="submit"
        src="../../assets/images/PNG/transparantcheckmark.png"
      />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    selected: Boolean,
  },
  methods: {
    handler() {
      this.selected = !this.selected;
      let myElement = this.$el.querySelectorAll(".checkbox");
      if (this.selected) {
        myElement[0].style.border = "none";
      } else {
        myElement[0].style.border = "1px solid #dbdbdb;";
      }
    },
    mouseOver() {
      let myElement = this.$el.querySelectorAll(".checkbox");

      myElement[0].style.background = "#EFEFEF";
    },
    mouseOut() {
      let myElement = this.$el.querySelectorAll(".checkbox");

      myElement[0].style.background = "#FFFFFF";
    },
  },
};
</script>

<style scoped>
.checkbox {
  width: 20px; 
  height: 20px; 
  border-radius: 100%; 
  background: white; 
  border: 1px solid #dbdbdb;  
  box-shadow: inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05);
  cursor: pointer; 
  outline:none; 
  margin-left: 0.5em; 
  padding: 0;
}
</style>